var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsageGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.33,
    y: 1.08,
    width: 20.46,
    height: 20.46,
    rx: 10.23,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.33,
    y: 1.08,
    width: 20.46,
    height: 20.46,
    rx: 10.23,
    stroke: "#61C554",
    strokeWidth: 0.66
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_40628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1565 12.8241H13.9268V11.0269C13.9268 10.9749 13.8843 10.9323 13.8323 10.9323H10.9V9.79723H12.177C12.281 9.79723 12.3661 9.7121 12.3661 9.60805V6.20285C12.3661 6.0988 12.281 6.01367 12.177 6.01367H8.77175C8.66771 6.01367 8.58258 6.0988 8.58258 6.20285V9.60805C8.58258 9.7121 8.66771 9.79723 8.77175 9.79723H10.0487V10.9323H7.11645C7.06443 10.9323 7.02186 10.9749 7.02186 11.0269V12.8241H5.79221C5.68816 12.8241 5.60303 12.9092 5.60303 13.0132V16.4184C5.60303 16.5225 5.68816 16.6076 5.79221 16.6076H9.1974C9.30145 16.6076 9.38658 16.5225 9.38658 16.4184V13.0132C9.38658 12.9092 9.30145 12.8241 9.1974 12.8241H7.87316V11.7836H13.0755V12.8241H11.7513C11.6473 12.8241 11.5621 12.9092 11.5621 13.0132V16.4184C11.5621 16.5225 11.6473 16.6076 11.7513 16.6076H15.1565C15.2605 16.6076 15.3457 16.5225 15.3457 16.4184V13.0132C15.3457 12.9092 15.2605 12.8241 15.1565 12.8241ZM8.48799 13.7227V15.709H6.50162V13.7227H8.48799ZM9.48117 8.89863V6.91227H11.4675V8.89863H9.48117ZM14.4471 15.709H12.4607V13.7227H14.4471V15.709Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_40628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.594,
    height: 10.594,
    fill: "white",
    transform: "translate(5.17725 6.01367)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageGreen);
export default __webpack_public_path__ + "static/media/Usage-Green.57cec4ac6ad57a36a4749c8798590f12.svg";
export { ForwardRef as ReactComponent };